/* eslint-disable no-nested-ternary */
import React, { Suspense, useEffect, useMemo, useRef, useState } from "react";
import { Outlet } from "react-router-dom";
import { ReactComponent as ExpandFalse } from "../../../assets/images/expandFalse.svg";
import { ReactComponent as ExpandTrue } from "../../../assets/images/expandTrue.svg";

import Footer from "../../Footer";
import Header from "../../Header";
import LoadingModal from "../../LoadingModal";

import { useAdminPermission } from "../../../hooks/useAdminPermission";
import { useAuth } from "../../../hooks/useAuth";
import { usePublicConfig } from "../../../hooks/usePublicConfig";
import { getScrollPage, SHOPIFY_ENV } from "../../../utils";

import { StyledButton, StyledContainer, StyledMain, Wrapper } from "./styles";

const LazyLayout = ({ offLayout }) => {
  const { user } = useAuth();
  const { env } = usePublicConfig();
  const isAdmin = useAdminPermission();
  const [hiddenMenu, setHiddenMenu] = useState(false);
  const [isMenuVisible, setIsMenuVisible] = useState(true);
  const layoutRef = useRef(null);
  const isVisibleHeader = process.env.REACT_APP_VISIBLE_HEADER;
  const hiddenHeader = SHOPIFY_ENV.includes(env?.hostEnv);

  const toggleMenuVisibility = () => {
    setIsMenuVisible((prev) => !prev);
  };

  const getLayoutHeight = useMemo(() => {
    const baseHeight =
      isAdmin || !user?.id ? "109px" : hiddenMenu ? "64px" : "123px";

    if ((isVisibleHeader && !isMenuVisible) || hiddenHeader) {
      return "100%";
    }

    return `calc(100% - ${baseHeight})`;
  }, [
    isAdmin,
    user?.id,
    hiddenMenu,
    isVisibleHeader,
    isMenuVisible,
    hiddenHeader,
  ]);

  useEffect(() => {
    getScrollPage(layoutRef, setHiddenMenu);
  }, []);

  return (
    <>
      {!offLayout && (
        <>
          {isVisibleHeader ? (
            <Wrapper>
              {isMenuVisible && <Header hiddenMenu={hiddenMenu} />}
              <StyledButton onClick={toggleMenuVisibility}>
                {isMenuVisible ? (
                  <>
                    <ExpandTrue />
                    Hide Additional Navigation
                  </>
                ) : (
                  <>
                    <ExpandFalse />
                    Show Additional Navigation
                  </>
                )}
              </StyledButton>
            </Wrapper>
          ) : (
            <>{!hiddenHeader && <Header hiddenMenu={hiddenMenu} />}</>
          )}

          <StyledContainer ref={layoutRef} $height={getLayoutHeight}>
            <StyledMain>
              <Suspense fallback={<LoadingModal isLoading />}>
                <Outlet />
              </Suspense>
            </StyledMain>

            <Footer />
          </StyledContainer>
        </>
      )}

      {offLayout && (
        <Suspense fallback={<LoadingModal isLoading />}>
          <Outlet />
        </Suspense>
      )}
    </>
  );
};

export default LazyLayout;
